/*
 * @Description:
 * @Version: 1.0
 * @Author: zhuangyuan
 * @Date: 2021-11-10 10:07:05
 * @LastEditors: zhuangyuan
 * @LastEditTime: 2022-05-23 15:19:52
 * @FilePath: \cqliving-sdzwpy-h5\src\components\dialog\Index.ts
 */
import Dialog from "./Dialog.vue";
import { IDialog } from "./type";
let mask: HTMLDivElement | null;

/**
 * 打开弹框
 */
export const showDialog: IDialog = (dialogType, text) => {
  return createDialog({ dialogType, text });
};
showDialog.phone = (openId: string) => {
  return createDialog({ dialogType: "phone", openId });
};

function createDialog(parms: any) {
  return new Promise(resolve => {
    if (!mask) {
      notice = () => {
        resolve("");
      };
      mask = document.createElement("div");
      const child = document.createElement("div");
      mask.appendChild(child);
      const sv = new Dialog({
        propsData: parms
      });
      sv.$mount(child);
      document.body.appendChild(mask);
      document.body.style.overflow = "hidden";
    } else {
      notice = () => {
        resolve("");
      };
    }
  });
}

/**
 * 关闭弹框
 */
export function closeDialog() {
  notice();
  document.body.style.overflow = "auto";
  mask!.remove();
  mask = null;
}

let notice = () => {};
